import { interfaces } from 'inversify'
import { Ref } from 'vue'

import { SubParticipant } from '@collector/sportsapi-client-legacy'
import { EventSettings } from '@mobile/reusables/types/EventSettings'

import { ActiveParticipant } from './ActiveParticipant'

type SI<T> = interfaces.ServiceIdentifier<T>

interface CricketRelationIoCBindingsInterface {
  ActiveParticipant: SI<Ref<ActiveParticipant>>
  EventSubParticipants: SI<Ref<SubParticipant[]>>
  EventSettings: SI<Ref<EventSettings>>
}

export const CricketRelationIoCBindings: CricketRelationIoCBindingsInterface = {
  ActiveParticipant: Symbol('ActiveParticipant'),
  EventSubParticipants: Symbol('EventSubParticipants'),
  EventSettings: Symbol('EventSettings'),
}
